import Api from 'services/api/calculators/monetary';

const mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    RESET: 'RESET',
};

// Initial State
const state = {
    amount: 0,
    minMonth: null,
    minYear: null,
    maxMonth: 9,
    maxYear: 2017,
    rpiData: [],
};

// Getters
const getters = {
    amount: state => state.amount,
    minMonth: state => state.minMonth,
    minYear: state => state.minYear,
    maxMonth: state => state.maxMonth,
    maxYear: state => state.maxYear,
    rpiData: state => state.rpiData,
};

// Actions
const actions = {
    loadRpiData({commit, state}) {
        if (state.rpiData.length) {
            return;
        }

        Api.rpiTable()
            .then(value => {
                commit(mutationTypes.UPDATE_VALUE, {key: 'rpiData', value});
            });
    },
    updateValue({commit}, {key, value}) {
        commit(mutationTypes.UPDATE_VALUE, {key, value});
    },
    reset({ commit }) {
        commit(mutationTypes.RESET);
    },
};

// Mutations
const mutations = {
    [mutationTypes.UPDATE_VALUE](state, payload) {
        state[payload.key] = payload.value;
    },
    [mutationTypes.RESET](state) {
        state.amount = 0;
        state.minMonth = null;
        state.minYear = null;
        state.maxMonth = null;
        state.maxYear = null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/mini/inflation.js